import {LanguageDict} from "../types";
import dayjs, {Dayjs} from "dayjs";

export default class DeathEvent {
    public id: string
    public date: string
    public description: string
    public fees: number
    public nameEn: string
    public nameFr: string
    public platformFees: number
    public unitFees: number
    public amountCollected: number
    public effectiveMembersCount: number
    public amountDue: number
    public coverageAmount: number
    public objectiveAmount: number
    public fixedChargeAmount: number
    public penalityCollected: number
    public penalityDue: number
    public createdAt: Dayjs
    public deadline: Dayjs
    public updatedAt: Dayjs
    public files: string

    constructor(data: any) {
        this.id = data.reference
        this.date = data.date
        this.description = data.description
        this.fees = data.fees
        this.amountCollected = data.amountCollected
        this.effectiveMembersCount = data.effectiveMembersCount
        this.amountDue = data.amountDue
        this.coverageAmount = data.coverageAmount
        this.objectiveAmount = data.objectiveAmount
        this.fixedChargeAmount = data.fixedChargeAmount
        this.penalityCollected = data.penalityCollected
        this.penalityDue = data.penalityDue
        this.nameEn = data.nameEn
        this.nameFr = data.nameFr
        this.platformFees = data.platformFees
        this.unitFees = data.unitFees
        this.createdAt = dayjs(data.createdAt)
        this.deadline = dayjs(data.deadline).subtract(1, 'day').hour(23)
        this.updatedAt = dayjs(data.updatedAt)
        this.files = data.files;
    }

    getName = (locale: LanguageDict): string => {
        // @ts-ignore
        return this[`name${locale[0].toUpperCase()}${locale.substring(1)}`]
    }
}
